import {WHITE_MUTED} from '../colors'
import {strokeModels, strokeModelsList} from './stroke-dasharray'

export const DIRECT_PATH = 'direct-path'

export function getDirectPathModel(
    blockFromId,
    blockToId,
    text = '',
    stroke = WHITE_MUTED,
    lineType = strokeModels.solid.value,
    visible = true
) {
    return {
        type: DIRECT_PATH,
        from: blockFromId,
        to: blockToId,
        visible,
        attrs: {
            text,
            stroke,
            'stroke-dasharray': lineType
        },
        editableAttrs: {
            stroke: {
                label: 'Color',
                type: 'color'
            },
            text: {
                label: 'Text',
                type: 'text'
            },
            'stroke-dasharray': {
                label: 'Line type',
                type: 'multiselect',
                multiselect: {
                    options: strokeModelsList,
                    label: 'label',
                    'track-by': 'value',
                    placeholder: 'Select line type'
                }
            }
        }
    }
}
